module.exports = __webpack_public_path__ + "static/img/02.56d014b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/peterschmid/02.jpg
// module id = 436
// module chunks = 1